export var LinkPositionDataKeysOptions;
(function (LinkPositionDataKeysOptions) {
    LinkPositionDataKeysOptions["GLBN"] = "GLBN";
    LinkPositionDataKeysOptions["SUB_NAV"] = "SubNav";
    LinkPositionDataKeysOptions["LEFT_NAV"] = "LeftNav";
    LinkPositionDataKeysOptions["RIGHT_NAV"] = "RightNav";
    LinkPositionDataKeysOptions["BODY"] = "Body";
    LinkPositionDataKeysOptions["BODY_ALERTS"] = "Body_Alerts";
    LinkPositionDataKeysOptions["BODY_LOGIN_WIDGET"] = "Body_LoginWidget";
    LinkPositionDataKeysOptions["BODY_MESSAGE"] = "Body_Message";
    LinkPositionDataKeysOptions["MARQUEE"] = "Marquee";
    LinkPositionDataKeysOptions["CAROUSEL"] = "Carousel";
    LinkPositionDataKeysOptions["TAB"] = "Tab";
    LinkPositionDataKeysOptions["LINK_FARM"] = "LinkFarm";
    LinkPositionDataKeysOptions["FOOTER"] = "Footer";
    LinkPositionDataKeysOptions["HEADER"] = "Header";
    LinkPositionDataKeysOptions["QUICK_LINKS"] = "QuickLinks";
    LinkPositionDataKeysOptions["LINK_FARM_1"] = "LinkFarm_1";
    LinkPositionDataKeysOptions["LINK_FARM_2"] = "LinkFarm_2";
    LinkPositionDataKeysOptions["LINK_FARM_3"] = "LinkFarm_3";
})(LinkPositionDataKeysOptions || (LinkPositionDataKeysOptions = {}));
/*** Event actions types. */
export var EventActions;
(function (EventActions) {
    EventActions["PAGE_LOAD"] = "pageLoad";
    EventActions["LINK_CLICK"] = "linkClick";
    EventActions["SYSTEM_EVENT"] = "systemEvent";
    EventActions["FORM_RESPONSE"] = "formResponse";
    EventActions["FORM_SUBMIT"] = "formSubmit";
    EventActions["IMPRESSION"] = "impression";
    EventActions["MARKETING"] = "marketing";
})(EventActions || (EventActions = {}));
export var ErrorTypeOption;
(function (ErrorTypeOption) {
    ErrorTypeOption["Success_Admit"] = "Success_Admit";
    ErrorTypeOption["Planned_Downtime"] = "Planned_Downtime";
    ErrorTypeOption["Failure_BusinessRule"] = "Planned_Downtime";
    ErrorTypeOption["Failure_User"] = "Failure_User";
    ErrorTypeOption["Failure_System"] = "Failure_System";
    ErrorTypeOption["Failure_Data"] = "Failure_Data";
    ErrorTypeOption["UNKNOWN"] = "";
})(ErrorTypeOption || (ErrorTypeOption = {}));
export var SuccessFlags;
(function (SuccessFlags) {
    /** User’s action was successful */
    SuccessFlags[SuccessFlags["SUCCESSFUL"] = 1] = "SUCCESSFUL";
    /** User’s action unsuccessful
     * (system errors, e.g. back end system down or unrecognized user input/blank fields/etc.
     */
    SuccessFlags[SuccessFlags["UNSUCCESSFUL"] = 0] = "UNSUCCESSFUL";
    /** User cancelled the action */
    SuccessFlags[SuccessFlags["USER_CANCEL"] = -1] = "USER_CANCEL";
    /** Unknown */
    SuccessFlags[SuccessFlags["UNKNOWN"] = -2] = "UNKNOWN";
})(SuccessFlags || (SuccessFlags = {}));
//# sourceMappingURL=AnalyticsEvents.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/AnalyticsEvents.js
// module id = 153
// module chunks = 8